import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
  ValidationErrors,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { Button } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { Message, MessageModule } from 'primeng/message';
import { InputTextModule } from 'primeng/inputtext';
import { Dialog, DialogModule } from 'primeng/dialog';
import { CommonModule } from '@angular/common';
import { InputNumber, InputNumberModule } from 'primeng/inputnumber';
import { duracaoAnosMaxValidator } from '@core/validators/date-range.validator';

@Component({
  selector: 'app-plano-curricular-cadastrar-editar',
  imports: [
    Button,
    FormsModule,
    ReactiveFormsModule,
    MessageModule,
    CalendarModule,
    InputTextModule,
    DialogModule,
    Dialog,
    Message,
    CommonModule,
    InputNumber,
    InputNumberModule,
  ],
  templateUrl: './plano-curricular-cadastrar-editar.component.html',
  styleUrl: './plano-curricular-cadastrar-editar.component.scss',
})
export class PlanoCurricularCadastrarEditarComponent
  implements OnInit, OnChanges
{
  @Input() instituicaoDeEnsinoCursoID: number | null = null; // Recebe o ID da instituição de ensino curso
  @Output() savePlanoCurricularEvent = new EventEmitter<any>(); // Emite os valores do formulário ao salvar
  @Output() close = new EventEmitter<void>();
  @Input() planoCurricular: any | null = null; // Recebe o plano curricular atual
  @Input() visiblePlanoCurricularForm = false; // Controla a exibição do modal
  planoCurricularForm: FormGroup;
  currentYear: number = new Date().getFullYear(); // Ano atual para o range do calendário

  constructor(private fb: FormBuilder) {
    // Inicializando o formulário com validação customizada
    this.planoCurricularForm = this.fb.group(
      {
        id: [0],
        designacao: ['', Validators.required],
        anoInicio: [null],
        anoFim: [null],
        activo: [true],
        cargaHoraria: [0, [Validators.required, Validators.min(0)]],
        duracaoAnos: ['', Validators.required], // Calculado automaticamente
        quantidadeAnosCurricular: [0, Validators.required],
      },
      { validators: duracaoAnosMaxValidator }
    );
    this.planoCurricularForm
      .get('quantidadeAnosCurricular')
      ?.valueChanges.subscribe((value) => {
        if (value && !isNaN(value)) {
          this.planoCurricularForm.patchValue(
            { duracaoAnos: value },
            { emitEvent: false }
          );
        }
      });
  }

  ngOnChanges(): void {
    if (this.planoCurricular) {
      this.planoCurricularForm.patchValue({
        id: this.planoCurricular.id,
        designacao: this.planoCurricular.designacao,
        anoInicio: this.planoCurricular.anoInicio
          ? new Date(this.planoCurricular.anoInicio)
          : null,
        anoFim: this.planoCurricular.anoFim
          ? new Date(this.planoCurricular.anoFim)
          : null,
        activo: this.planoCurricular.activo,
        quantidadeAnosCurricular: this.planoCurricular.quantidadeAnosCurricular,
        cargaHoraria: this.planoCurricular.cargaHoraria,
      });
    } else {
      // this.planoCurricularForm.reset();
    }
  }

  ngOnInit(): void {
    // this.planoCurricularForm.valueChanges.subscribe(() => {
    //   const anoInicio = this.planoCurricularForm.get('anoInicio')?.value;
    //   const anoFim = this.planoCurricularForm.get('anoFim')?.value;

    //   const inicio = anoInicio instanceof Date ? anoInicio.getFullYear() : null;
    //   const fim = anoFim instanceof Date ? anoFim.getFullYear() : null;

    //   if (inicio !== null && fim !== null && fim >= inicio) {
    //     const calc = fim - inicio;
    //     this.planoCurricularForm.patchValue(
    //       { duracaoAnos: calc, quantidadeAnosCurricular: calc },
    //       { emitEvent: false }
    //     );
    //   } else {
    //     this.planoCurricularForm.patchValue(
    //       { duracaoAnos: 0, quantidadeAnosCurricular: 0 },
    //       { emitEvent: false }
    //     );
    //   }
    // });
  }

  savePlanoCurricular(): void {
    if (this.planoCurricularForm.valid) {
      const formData = {
        ...this.planoCurricularForm.getRawValue(),
        instituicaoDeEnsinoCursoID: this.instituicaoDeEnsinoCursoID, // Inclui o ID recebido no output
      };
      this.savePlanoCurricularEvent.emit(formData); // Emite os valores do formulário
    } else {
      this.planoCurricularForm.markAllAsTouched();
    }
  }
}
